export const ACCOUNT_READY_EVENT = "authhub:account-ready";

const READY_DATASET_KEY = "authhubAccountReady";
const STARTUP_OVERLAY_ID = "authhub-startup-overlay";

const getStartupOverlay = () => document.getElementById(STARTUP_OVERLAY_ID);

export const hideStartupOverlay = () => {
  document.documentElement.dataset[READY_DATASET_KEY] = "true";
  getStartupOverlay()?.setAttribute("data-state", "hidden");
};

export const notifyAccountReady = () => {
  hideStartupOverlay();
  window.dispatchEvent(new Event(ACCOUNT_READY_EVENT));
};

export const isAccountReadyMarked = () =>
  document.documentElement.dataset[READY_DATASET_KEY] === "true";
